import React from 'react'
import Header from '../HeaderandFooter/Header'
import SourceCode from './SourceCode'
import SidebarOptions from '../HeaderandFooter/SidebarOptions'
import { Helmet } from "react-helmet-async";


const MainSourceCode = () => {
    return (
        <>
            <Helmet>
                <title>Simple Source Code | SuperCodingBits</title>
                <meta name="description" content="Write clean, efficient, and maintainable React.js code with SuperCodingBits | Simple Code. Learn best practices, minimal yet powerful solutions, and smart coding techniques to build scalable front-end applications" />
                <meta name="keywords" content="React.js, front-end development, UI components, reusable components, responsive design, clean code, JavaScript, web development" />
            </Helmet>
            <Header />
            <SidebarOptions />
            <div className="sectiondata">
                <SourceCode />
            </div>
        </>
    )
}

export default MainSourceCode